
export const ActiveCompanies = () => {
    return (
        <div>ActiveCompanies</div>
    )
}
